/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgxValidationMessageComponent } from './validation-message/validation-message.component';
import {
  NgxFilterByNumberComponent,
} from './custom-smart-table-components/filter-by-number/filter-by-number.component';
import { NbAlertModule, NbButtonModule, NbCardModule, NbProgressBarModule, NbTabsetModule, NbUserModule, NbIconModule, NbSelectModule, NbListModule, NbSpinnerModule, NbCalendarKitModule, NbCalendarModule, NbCalendarRangeModule, NbStepperModule, NbDialogModule, NbToggleModule, NbInputModule, NbFormFieldModule, NbAccordionModule, NbTagModule, NbChatModule, NbDatepickerModule, NbCheckboxModule, NbActionsModule, NbButtonGroupModule, NbPopoverModule, NbAutocompleteModule } from '@nebular/theme';
import { Angular2SmartTableModule } from 'angular2-smart-table';
import { RelationSelectionComponent } from './customFields/relation-selection/relation-selection.component';
import { FileFieldComponent } from './customFields/file-field/file-field.component';
import { Ng2SmartTableEditorsSharedModule } from './custom-smart-table-components/ng2-smart-table-editors/ng2-smart-table-editors.shared.module';
import { ChatBotComponent } from './chat-bot/chat-bot.component';

const CUSTOM_COMPONENTS = [
  NgxValidationMessageComponent,
  NgxFilterByNumberComponent,
  RelationSelectionComponent, 
  FileFieldComponent,
  ChatBotComponent
];

const MODULES = [
  NbAlertModule,
  NbButtonModule,
  NbCardModule,
  NbProgressBarModule,
  NbTabsetModule,
  NbUserModule,
  NbIconModule,
  NbSelectModule,
  NbListModule,
  NbSpinnerModule,
  NbCalendarKitModule,
  NbCalendarModule,
  NbCalendarRangeModule,
  NbStepperModule,
  NbDialogModule,
  NbToggleModule,
  NbInputModule,
  NbFormFieldModule,
  NbUserModule,
  NbAccordionModule,
  NbTagModule,
  NbChatModule,
  NbDatepickerModule,
  NbCheckboxModule,
  NbActionsModule,
  NbButtonGroupModule,
  Angular2SmartTableModule,
  NbPopoverModule,
  NbAutocompleteModule,
]

@NgModule({
  imports: [
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    ...MODULES,
  ],
  exports: [...CUSTOM_COMPONENTS, ...MODULES],
  declarations: [...CUSTOM_COMPONENTS,],
  entryComponents: [
    NgxFilterByNumberComponent,
  ],
})
export class ComponentsModule {
}
